export enum TimeFormat {
	H24 = '24H',
	H12 = '12H',
}
